import {
	formatAsMonth,
	formatAsMonthAndYear,
	formatAsYear,
} from "../../../../../core/helpers/date-formatting-util.js";
import { formatCurrency } from "../../../../../core/helpers/currency-formatting-util.js";

/**
 * Abstract strategy for ForecastFiscalYearCard. Subclasses are used
 * to render the ForecastFiscalYear according to the current report.
 *
 * @abstract
 */
export default class AbstractForecastFiscalYearCardRenderingStrategy {
	renderContentAsBigCardOn(_html) {
		throw new Error("Subclass responsibility");
	}

	renderContentAsOneLinerOn(_html) {
		throw new Error("Subclass responsibility");
	}

	setValues() {}

	_valueRenderer({ value }) {
		if (value === null || value === undefined) {
			return "-";
		}

		return this._format(value);
	}

	_format(value) {
		return formatCurrency(value);
	}

	_getValue() {}

	_cssClass() {
		return [
			"ForecastFiscalYearCard",
			{
				positive: this._getValue() >= 0,
				negative: this._getValue() < 0,
			},
		];
	}

	_timespanRenderer(timespan) {
		return (html) =>
			html.div(
				{
					"data-test": "periods",
					class: "periods",
				},
				this._smartPeriodNameRenderer({
					start: timespan?.getStart(),
					end: timespan?.getEnd(),
				}),
			);
	}

	_smartPeriodNameRenderer({ start, end }) {
		if (!start || !end) {
			return () => {};
		}

		const startString = this._getStartString({ start, end });
		const endString = this._getEndString({ start, end });

		return (html) => {
			html.span(startString);

			if (endString === startString) {
				return;
			}

			html.span({ class: "fa fa-arrow-right" });
			html.span(endString);
		};
	}

	_getStartString({ start, end }) {
		const startYear = formatAsYear(start);
		const endYear = formatAsYear(end);

		return startYear === endYear
			? formatAsMonth(start)
			: formatAsMonthAndYear(start);
	}

	_getEndString({ start, end }) {
		const startYear = formatAsYear(start);
		const endYear = formatAsYear(end);

		return startYear === endYear
			? formatAsMonth(end)
			: formatAsMonthAndYear(end);
	}
}
